import { z } from 'zod';

export const ExplainImageResult = z.object({
  explanation: z.string(),
});

export type ExplainImageResult = z.infer<typeof ExplainImageResult>;

export const ExplainImageRequest = z.object({
  dataUrl: z.string(),
});

export type ExplainImageRequest = z.infer<typeof ExplainImageRequest>;
